<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row v-if="unitswithgroups.includes(selWing.toUpperCase())" dense>
          <v-col class="text-center blue darken-4 listHeader">
          <div class="topHeader"><label class="white--text font-weight-bold">{{groupid}}<br /> Units</label></div>
          </v-col>
        </v-row>
        <v-row v-else dense>
          <v-col class="pa-0 ma-0">
            <div class="text-center" ><label class="font-weight-black blue--text text--darken-4 title">Select a Unit Below</label></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-0 ma-0">
            <v-list two-line>
              <v-list-item-group active-class="blue--text">
                <template v-for="(item, index) in units">
                  <v-list-item :key="index + 'item'">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="item.unitname"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.charternumber"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text >
                          <v-btn depressed outlined text icon medium color="blue darken-4" :to="`/skillevaluator/byunit/${groupid}/${item.orgid}`">
                              <v-icon>mdi-chevron-right</v-icon>
                          </v-btn>
                        </v-list-item-action-text>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider :key="index + 'divider'" />
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>    
</template>

<script>
export default {
  name: 'SkillEvaluatorByUnit',
  props: {
    groupid: {
      type: String,
      default: null
    }
  },
  components: {
  },
  data() {
    return {
      isLoading: false,
      units: []
    }
  },
  mounted() {
    this.getUnitsForTopLevelGroup();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getUnitsForTopLevelGroup() {

      this.isLoading = true;

      this.$https.post(this.$vars.BaseUrl + this.$vars.GetUnitsForTopLevelGroupRoute, {
          wing: this.selWing,
          toplevelgroupname: this.groupid
        }, this.$vars.config)
        .then(response => {
          //console.log(response);
          this.httpResponse = response;
          this.units = response.data;
          this.setUnitList(response.data);
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });

    }
  }
}
</script>